import { Content } from "@/ui";
import { specialisms_helper } from "@/helpers/specialisms_helper";
import { createTitle } from "@/functions/createTitle";
import { getRoute } from "@/functions/getRoute";
import * as additionalComponents from "./__components";
import { jobSearch } from "@/functions/jobSearch";
import unslug from "unslug";
import _ from "lodash";
import sn from "@/snippets";

export default function SpecialismPage({ content }) {
  return (
    <>
      <Content items={content} additionalComponents={additionalComponents} />
    </>
  );
}

export async function getStaticProps({ params: { url_slugs } }) {
  let pages = url_slugs.map((url_slug, k) => ({
    url_slug,
    label: unslug(url_slug),
    href: getRoute("specialisms", { url_slugs: url_slugs.slice(0, k + 1) }),
  }));

  pages.unshift({
    url_slug: "jobs",
    label: "Find a job",
    href: "/jobs/",
  });

  const [_page, prevPage] = [...pages].reverse();
  const page = specialisms_helper.find(_page.url_slug);

  const jobs = _.uniqBy(
    _.flatten(
      await Promise.all(
        (page?.show_related_jobs ?? []).map(
          async ({ query, location, radius }) =>
            await jobSearch({
              query,
              location,
              radius: radius ? parseInt(radius) : null,
            }),
        ),
      ),
    ),
    "id",
  );

  if (!page) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      meta: {
        title: createTitle(page.title),
      },
      content: [
        {
          id: "BreadcrumbNavigation",
          component: "BreadcrumbNavigation",
          props: {
            items: pages,
          },
        },
        sn.header({ page, prevPage }),
        {
          id: "SpecialismPageContent",
          component: "SpecialismPageContent",
          props: {
            body: page.body ?? "",
            secondaryContent: page.secondary_content ?? "",
            consultants: page.consultants ?? "",
            collapsibleSectionTitle: page.collapsible_section_title ?? "",
            collapsibleSectionBody: page.collapsible_section_description ?? "",
            collapsibleSectionItems: page.collapsible_section_items ?? [],
            jobs,
          },
        },
      ],
    },
  };
}

export async function getStaticPaths() {
  return {
    paths: specialisms_helper.toNestedPaths(),
    fallback: false,
  };
}
